import { __read, __spreadArray } from "tslib";
import { chainFunctions } from './chain-functions';
import { get, set, flatten } from 'lodash';
import { isScalarType } from 'graphql';
import { asArray } from '@graphql-tools/utils';
function resolveRelevantMappings(resolvers, path, allMappings) {
    var split = path.split('.');
    if (split.length === 2) {
        var typeName_1 = split[0];
        if (isScalarType(resolvers[typeName_1])) {
            return [];
        }
        var fieldName_1 = split[1];
        if (typeName_1 === '*') {
            return flatten(Object.keys(resolvers).map(function (typeName) {
                return resolveRelevantMappings(resolvers, typeName + "." + fieldName_1, allMappings);
            }));
        }
        if (fieldName_1 === '*') {
            return flatten(Object.keys(resolvers[typeName_1]).map(function (field) {
                return resolveRelevantMappings(resolvers, typeName_1 + "." + field, allMappings);
            })).filter(function (mapItem) { return !allMappings[mapItem]; });
        }
        else {
            var paths = [];
            if (resolvers[typeName_1] && resolvers[typeName_1][fieldName_1]) {
                if (resolvers[typeName_1][fieldName_1].subscribe) {
                    paths.push(path + '.subscribe');
                }
                if (resolvers[typeName_1][fieldName_1].resolve) {
                    paths.push(path + '.resolve');
                }
                if (typeof resolvers[typeName_1][fieldName_1] === 'function') {
                    paths.push(path);
                }
            }
            return paths;
        }
    }
    else if (split.length === 1) {
        var typeName_2 = split[0];
        return flatten(Object.keys(resolvers[typeName_2]).map(function (fieldName) {
            return resolveRelevantMappings(resolvers, typeName_2 + "." + fieldName, allMappings);
        }));
    }
    return [];
}
/**
 * Wraps the resolvers object with the resolvers composition objects.
 * Implemented as a simple and basic middleware mechanism.
 *
 * @param resolvers - resolvers object
 * @param mapping - resolvers composition mapping
 * @hidden
 */
export function composeResolvers(resolvers, mapping) {
    if (mapping === void 0) { mapping = {}; }
    var mappingResult = {};
    Object.keys(mapping).forEach(function (resolverPath) {
        if (mapping[resolverPath] instanceof Array || typeof mapping[resolverPath] === 'function') {
            var composeFns_1 = mapping[resolverPath];
            var relevantFields = resolveRelevantMappings(resolvers, resolverPath, mapping);
            relevantFields.forEach(function (path) {
                mappingResult[path] = asArray(composeFns_1);
            });
        }
        else {
            Object.keys(mapping[resolverPath]).forEach(function (fieldName) {
                var composeFns = mapping[resolverPath][fieldName];
                var relevantFields = resolveRelevantMappings(resolvers, resolverPath + '.' + fieldName, mapping);
                relevantFields.forEach(function (path) {
                    mappingResult[path] = asArray(composeFns);
                });
            });
        }
    });
    Object.keys(mappingResult).forEach(function (path) {
        var fns = chainFunctions(__spreadArray(__spreadArray([], __read(asArray(mappingResult[path]))), [function () { return get(resolvers, path); }]));
        set(resolvers, path, fns());
    });
    return resolvers;
}
//# sourceMappingURL=resolvers-composition.js.map